import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import React from "react";
import styled from "styled-components";

import { useTranslate } from '@tolgee/react';

const RequestJoinmeetingModal = ({ open, handleDeny, handleApprove, user, atCapacity }) => {
  const { t } = useTranslate();
  if (!user) {
    return
  }

  let userNameDetails = user.user.phone_number || user.user.email
  return (
    <CustomDialog
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <CustomDialogContent>
        <Title>
          {t('meetings.request_to_join')}
        </Title>
        <Details>  <span>{user.user.name} {userNameDetails && `(${userNameDetails})`}</span>  {t('meetings.want_to_join')}</Details>
        {atCapacity && <CapacityNotice>{t('meetings.meeting_at_capacity')}</CapacityNotice>}
      </CustomDialogContent>

      <DialogActionsCustom>
        <Button
          onClick={() => handleDeny(user)}
          className="btn closeBtn"
        >
          {t('general.deny')}
        </Button>
        <Button
          className="btn answerBtn"
          onClick={() => handleApprove(user)}
          disabled={atCapacity}
          autoFocus
        >
          {t('meetings.approve')}
        </Button>
      </DialogActionsCustom>
    </CustomDialog>
  );
};

export default RequestJoinmeetingModal;

const CustomDialog = styled(Dialog)`

    .MuiDialog-paper {
    padding:0;
      border-radius: 4px;
      background: ${({ theme }) => theme.menu.background};
      min-width: 350px;
      max-width: 350px;
      border:1px solid ${({ theme }) => theme.sidebar.borderColor};
    }
  
    .btn {
      font-size: 16px;
      font-weight: 500;
      border-radius: 4px;
      min-width: 150px;
      text-transform: none !important;
    }
  
    .closeBtn {
      color: ${({ theme }) => theme.menu.deleteColor};
      background: transparent;
      border:1px solid ${({ theme }) => theme.menu.deleteColor};
      &:hover {
        background: ${({ theme }) => theme.primaryButton.removeBackground} !important;
      }
    }
  
    .answerBtn {
 color: white;
      background: ${({ theme }) => theme.valid_green};
      &:hover {
        background: green !important;
      }
      &.Mui-disabled {
        color: white;
        background: ${({ theme }) => theme.menu.avatarBackground};
        opacity: 0.6;
      }
    }
  `;
const CustomDialogContent = styled(DialogContent)`
    display: flex;
    flex-direction: column;
    gap: 15px;
    justify-conten: center;
    padding: 20px 20px 0 20px !important;
  `;

const Details = styled.h1`
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    span{
    color: ${({ theme }) => theme.menu.primaryTextColor};
    font-weight:500;
    }
  `;

const DialogActionsCustom = styled(DialogActions)`
    display: flex;
    justify-content: center !important;
    gap: 20px;
    webkit-justify-content: center;
    padding: 20px !important;
  `;

const Title = styled.h1`
font-size:16px;
color:${({ theme }) => theme.menu.selectedTextColor};
line-height:20px;
`

const CapacityNotice = styled.p`
  font-size: 13px;
  line-height: 18px;
  color: ${({ theme }) => theme.menu.deleteColor};
  margin: 0;
`